/**
 * CardFilterDropdown — Filter by card category (Traditional vs specific nontraditional types).
 * Multi-select dropdown built on the shared FilterDropdown component.
 * No icons — FilterDropdown renders label-text pills for icon-less options.
 */
import type { ReactElement } from 'react';

import type { FilterDropdownOption, FilterDropdownOptionGroup } from '@/components/FilterDropdown/FilterDropdown';
import FilterDropdown from '@/components/FilterDropdown/FilterDropdown';

export interface CardFilterDropdownProps {
  selectedCategories: string[];
  onToggle: (value: string) => void;
  onClear: () => void;
  className?: string;
}

const GROUPS: FilterDropdownOptionGroup[] = [
  { groupName: 'Traditional', style: { color: '#a1a1aa' } },
  { groupName: 'Non-Traditional', style: { color: '#a1a1aa' } },
];

const CARD_CATEGORY_OPTIONS: FilterDropdownOption[] = [
  // Traditional group
  { value: 'traditional', label: 'Traditional', group: 'Traditional', badgeClassName: 'bg-zinc-500/20 text-zinc-300' },
  // Non-Traditional group
  { value: 'token', label: 'Token', group: 'Non-Traditional', badgeClassName: 'bg-amber-500/20 text-amber-400' },
  { value: 'emblem', label: 'Emblem', group: 'Non-Traditional', badgeClassName: 'bg-amber-500/20 text-amber-400' },
  { value: 'art_series', label: 'Art Series', group: 'Non-Traditional', badgeClassName: 'bg-amber-500/20 text-amber-400' },
  { value: 'dungeon', label: 'Dungeon', group: 'Non-Traditional', badgeClassName: 'bg-amber-500/20 text-amber-400' },
  { value: 'plane', label: 'Plane', group: 'Non-Traditional', badgeClassName: 'bg-amber-500/20 text-amber-400' },
  { value: 'phenomenon', label: 'Phenomenon', group: 'Non-Traditional', badgeClassName: 'bg-amber-500/20 text-amber-400' },
  { value: 'scheme', label: 'Scheme', group: 'Non-Traditional', badgeClassName: 'bg-amber-500/20 text-amber-400' },
  { value: 'vanguard', label: 'Vanguard', group: 'Non-Traditional', badgeClassName: 'bg-amber-500/20 text-amber-400' },
  { value: 'conspiracy', label: 'Conspiracy', group: 'Non-Traditional', badgeClassName: 'bg-amber-500/20 text-amber-400' },
  { value: 'stickers', label: 'Stickers', group: 'Non-Traditional', badgeClassName: 'bg-amber-500/20 text-amber-400' },
  { value: 'attraction', label: 'Attraction', group: 'Non-Traditional', badgeClassName: 'bg-amber-500/20 text-amber-400' },
  { value: 'contraption', label: 'Contraption', group: 'Non-Traditional', badgeClassName: 'bg-amber-500/20 text-amber-400' },
];

export default function CardFilterDropdown({ selectedCategories, onToggle, onClear, className }: CardFilterDropdownProps): ReactElement {
  return (
    <FilterDropdown
      triggerLabel="Cards"
      ariaLabel="Card category filter"
      searchPlaceholder="Search categories..."
      groups={GROUPS}
      options={CARD_CATEGORY_OPTIONS}
      selectedValues={selectedCategories}
      onToggle={onToggle}
      onClear={onClear}
      maxTriggerIcons={1}
      className={className}
    />
  );
}
